"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postMessage = exports.isNode = exports.isWorker = exports.isBrowser = void 0;
function isBrowser() {
    return (typeof self !== 'undefined' && self.document !== undefined);
}
exports.isBrowser = isBrowser;
function isWorker() {
    return (typeof self !== 'undefined' && self.document === undefined);
}
exports.isWorker = isWorker;
function isNode() {
    return !isWorker() && !isBrowser() && typeof global === 'object';
}
exports.isNode = isNode;
var _self = (typeof self === 'undefined' && typeof global === 'object' ? global.self : self);
function postMessage(message, options) {
    return _self.postMessage(message, options);
}
exports.postMessage = postMessage;
//# sourceMappingURL=index.js.map